(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riwayat-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.riwayat-hero').forEach(function (hero) {
      var video = hero.querySelector('.riwayat-hero__video');
      var toggle = hero.querySelector('[data-riwayat-video-toggle]');
      if (!video) return;

      if (reducedMotion) {
        video.pause();
        video.removeAttribute('autoplay');
        return;
      }

      var showToggle = function () {
        if (toggle) toggle.hidden = false;
      };
      var hideToggle = function () {
        if (toggle) toggle.hidden = true;
      };

      var playPromise = video.play();
      if (playPromise && playPromise.then) {
        playPromise.then(hideToggle).catch(showToggle);
      }

      video.addEventListener('playing', hideToggle);
      video.addEventListener('pause', function () {
        if (!video.ended) showToggle();
      });

      if (toggle) {
        toggle.addEventListener('click', function () {
          video.muted = true;
          var retryPromise = video.play();
          if (retryPromise && retryPromise.then) {
            retryPromise.then(hideToggle).catch(function () {});
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riwayat-limited-offer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-riwayat-offer]').forEach(function (card) {
    var packButtons = Array.prototype.slice.call(card.querySelectorAll('[data-offer-variant-id]'));
    if (!packButtons.length) return;

    var priceEl = card.querySelector('[data-offer-sale-price]');
    var compareEl = card.querySelector('[data-offer-compare-price]');
    var saveBadge = card.querySelector('[data-offer-save-badge]');
    var priceRow = card.querySelector('[data-offer-price-row]');
    var cta = card.querySelector('[data-offer-cta]');

    packButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        packButtons.forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });

        var priceFormatted = btn.getAttribute('data-offer-variant-price');
        var compareFormatted = btn.getAttribute('data-offer-variant-compare');
        var hasCompare = btn.getAttribute('data-offer-variant-has-compare') === 'true';
        var save = btn.getAttribute('data-offer-variant-save');
        var url = btn.getAttribute('data-offer-variant-url');

        if (priceEl && priceFormatted) priceEl.textContent = priceFormatted;

        if (hasCompare) {
          if (compareEl) {
            compareEl.textContent = compareFormatted;
            compareEl.style.display = '';
          } else if (priceRow) {
            compareEl = document.createElement('span');
            compareEl.className = 'riwayat-offer__price riwayat-offer__price--compare';
            compareEl.setAttribute('data-offer-compare-price', '');
            compareEl.textContent = compareFormatted;
            priceRow.insertBefore(compareEl, priceRow.firstChild);
          }
          if (saveBadge) {
            saveBadge.textContent = 'Save ' + save + '%';
            saveBadge.style.display = '';
          }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (saveBadge) saveBadge.style.display = 'none';
        }

        if (cta && url) cta.setAttribute('href', url);
      });
    });
  });

  document.querySelectorAll('[data-riwayat-countdown]').forEach(function (el) {
    var endStr = el.getAttribute('data-end');
    var end = new Date(endStr).getTime();
    if (isNaN(end) || end <= Date.now()) {
      el.remove();
      return;
    }
    var valueEl = el.querySelector('[data-riwayat-countdown-value]');
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        el.remove();
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var parts = [];
      if (d > 0) parts.push(d + 'd');
      parts.push((h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s);
      if (valueEl) valueEl.textContent = parts.join(' ');
      el.hidden = false;
    }
    tick();
    setInterval(tick, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riwayat-tracking"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-riwayat-tracking-form]').forEach(function (form) {
      var proxyUrl = form.getAttribute('data-proxy-url');
      var input = form.querySelector('[name="tracking_number"]');
      var submitBtn = form.querySelector('[data-riwayat-tracking-submit]');
      var submitLabel = form.querySelector('[data-riwayat-tracking-submit-label]');
      var errorEl = form.querySelector('[data-riwayat-tracking-error]');
      var resultEl = form.parentElement.querySelector('[data-riwayat-tracking-result]');
      var numberEl = resultEl ? resultEl.querySelector('[data-riwayat-tracking-number]') : null;
      var statusEl = resultEl ? resultEl.querySelector('[data-riwayat-tracking-status]') : null;
      var timelineEl = resultEl ? resultEl.querySelector('[data-riwayat-tracking-timeline]') : null;

      function showError(message) {
        if (errorEl) {
          errorEl.textContent = message;
          errorEl.hidden = false;
        }
        if (resultEl) resultEl.hidden = true;
      }

      function clearError() {
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
      }

      function renderResult(trackingNumber, data) {
        var dist = data && (data.dist || data.data || data);
        var history = dist && (dist.transactionStatusHistory || dist.statusHistory || dist.history);
        var status = dist && (dist.transactionStatus || dist.orderStatus || dist.trackingStatus || dist.status);
        if (!status && Array.isArray(history) && history.length) {
          status = history[0].transactionStatusMessage || history[0].message || history[0].status;
        }

        if (numberEl) numberEl.textContent = trackingNumber;
        if (statusEl) statusEl.textContent = status || 'Status unavailable';

        if (timelineEl) {
          timelineEl.innerHTML = '';
          if (Array.isArray(history) && history.length) {
            history.forEach(function (event) {
              var li = document.createElement('li');
              var message = document.createElement('span');
              message.className = 'riwayat-tracking__timeline-message';
              message.textContent = event.transactionStatusMessage || event.message || event.status || 'Update';
              li.appendChild(message);
              var dateVal = event.modifiedDatetime || event.date || event.timestamp;
              if (dateVal) {
                var dateEl = document.createElement('span');
                dateEl.className = 'riwayat-tracking__timeline-date';
                dateEl.textContent = dateVal;
                li.appendChild(dateEl);
              }
              timelineEl.appendChild(li);
            });
          }
        }

        if (resultEl) resultEl.hidden = false;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();

        var trackingNumber = (input.value || '').trim();
        if (!trackingNumber) return;

        if (!proxyUrl) {
          showError('Tracking is not configured yet. Please check back soon.');
          return;
        }

        submitBtn.disabled = true;
        if (submitLabel) submitLabel.textContent = 'Tracking…';
        if (resultEl) resultEl.hidden = true;

        fetch(proxyUrl + '?trackingNumber=' + encodeURIComponent(trackingNumber))
          .then(function (res) {
            if (!res.ok) throw new Error('We could not find that tracking number. Please check it and try again.');
            return res.json();
          })
          .then(function (data) {
            renderResult(trackingNumber, data);
          })
          .catch(function (err) {
            showError(err.message || 'Something went wrong. Please try again.');
          })
          .finally(function () {
            submitBtn.disabled = false;
            if (submitLabel) submitLabel.textContent = 'Track';
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
